import { NAME_REGEXP } from 'app/lib/constants';
import { Yup } from 'app/components/core/Form';

export const AssetNameSchema = Yup.string()
    .matches(NAME_REGEXP, {
        message:
            "Names must not start with a whitespace, an underscore '_' or contain backticks '`'."
    })
    .trim()
    .max(100, 'Sorry, names can only be 100 characters long.')
    .meta({ summary: true })
    .required('Please provide a name.');
